import { IPricingWorkload } from "@shared/lib/types/pricingWorkload";
import { BackednResponse } from "@shared/lib/types/response";
import { Card, Typography } from "@shared/ui";
import { Select } from "@shared/ui/Select";
import { CircleUser } from "lucide-react";
import styles from "./MyPricing.module.scss";

const { Title, Text } = Typography;

type MyPricingPageHeaderProps = {
  isSuperUser: boolean;
  pricingWorkloadData?: BackednResponse<IPricingWorkload[]>;
  isPricingWorkloadLoading: boolean;
  pocSelectOptions: { label: string; value: string }[];
  pocSelectValue: string | null;
  onPocChange: (userId: string) => void;
};

export function MyPricingPageHeader({
  isSuperUser,
  pricingWorkloadData,
  isPricingWorkloadLoading,
  pocSelectOptions,
  pocSelectValue,
  onPocChange,
}: MyPricingPageHeaderProps) {
  return (
    <div className={styles.pageHeader}>
      <div className={styles.headerContent}>
        {/* <div className={styles.workspaceBadge}>
          <PackageCheck size={18} />
          Internal · POC workspace
        </div> */}
        <h1 className={styles.title}>
          My Pricing
        </h1>
        {/* <Text type="secondary" className={styles.pageDescription}>
          Your allocated briefs and pricing POC scores (0–10 per brief closure).
          Scores reflect commercial quality and whether you closed before the
          assigned deadline (−10% per day late).
        </Text> */}
      </div>

      {isSuperUser ? (
        <Card
          className={styles.pocCard}
          title={
            <span className={styles.pocLabel}>
              <CircleUser size={14} />
              <Text type="secondary">Working as POC</Text>
            </span>
          }
          styles={{
            header: {
              borderBottom: "none",
            },
          }}
        >
          {pricingWorkloadData ? (
            <Select
              options={pocSelectOptions}
              loading={isPricingWorkloadLoading}
              showSearch
              optionFilterProp="label"
              value={pocSelectValue}
              onChange={onPocChange}
              style={{ width: "100%" }}
              placeholder="Select a Pricing POC"
            />
          ) : null}
        </Card>
      ) : null}
    </div>
  );
}
